import { CamelCaseKeys } from "@utils/typescript";
import { UserLess } from "./User";

export enum CollaboratableTypes {
  InsurancePolicy = 'InsurancePolicy',
}

export type Collaboration = CamelCaseKeys<{
  id: number;
  created_at: number;
  collaborator: UserLess;
}>;
